import React, {useEffect, useState} from 'react';
import style from "./index.module.scss"
import cn from "classnames";
import Badge from "../../shared/Badge";
import {Driver, File} from '../../../services';
import {requestErrorDisplay} from '../../../utils';
import { t } from "i18next";
import { SquarePen } from "lucide-react";
import InviteLinkModal from '../InviteLinkModal/InviteLinkModal';
import DriverInfoModal from '../DriverInfoModal/DriverInfoModal';
import { RotateCcwKey } from 'lucide-react';
import AppTooltip from '../../shared/AppTooltip/AppTooltip';

const DriverItemCard = ({ isHead, item, isCnUser = false, onDriverUpdate }) => {
  const [ isLoading, setLoading ] = useState(false);
  const [ avatarData, setAvatarData ] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [inviteUrl, setInviteUrl] = useState("");
  const [expireLink, setExpireLink] = useState("");
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const getAvatarById = () => {
    setLoading(true)
    File.getImageByType(8, item.id)
      .then(res => res.data)
      .then(data => {
        setAvatarData(data)
      })
      .catch(e => {
        requestErrorDisplay(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleLinkClick = () => {
    setInviteUrl("");
    setExpireLink("");

    Driver.generateDriverUrl(item.id)
      .then(res => res.data)
      .then(data => {
        setInviteUrl(data.url);
        setExpireLink(data.expiry);
        setShowModal(true);
      })
      .catch(e => {
        requestErrorDisplay(e);
      });
  };

  const formatName = (name) => {
    if (!name) return '';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleDriverClick = () => {
    setShowInfoModal(true);
  };

  const handleInfoModalClose = () => {
    setShowInfoModal(false);
    setIsEditMode(false);
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    setIsEditMode(true);
    setShowInfoModal(true);
  };

  // useEffect(() => {
  //   if (!isHead && item?.id) {
  //     getAvatarById()
  //   }
  // }, [isHead, item?.id])

  return (
    <>
      <div className={cn(style.wrapper, { 
        [style.isHead]: isHead,
        [style.isCnUser]: isCnUser
      })}>
        {
          isHead && (
            <>
              <div className={style.item} style={{paddingLeft: '22px'}}>
                {/* <div className={style.item_avatar} style={{ height: "1px" }}></div> */}
                {t("driversHead.name")}
              </div>
              <div className={style.item}>
                {t("driversHead.licenseNumber")}
              </div>
              <div className={style.item}>
                {t("driversHead.phoneNumber")}
              </div>
              <div className={style.item} style={{ justifyContent: 'center'}}>
                {t("driversHead.link")}
              </div>
              <div className={cn(style.item, style.item_status)}>
                {t("driversHead.status")}
              </div>
              <div className={cn(style.item, style.item_edit)} style={{ paddingRight: "14px", justifyContent: 'center' }}>
                {t("profileTwo.buttons.edit")}
              </div>
            </>
          )
        }
        {
          !isHead && (
            <>
              <div className={style.item} onClick={handleDriverClick} style={{ paddingLeft: '22px', cursor: 'pointer' }}>
                {/* <img
                  className={style.item_avatar}
                  src={avatarData?.base64 ? `data:${avatarData?.contentType};base64, ${avatarData?.base64}` : '/images/no-photo.png'}
                  alt="No Avatar"
                /> */}
                {formatName(item.surname)} {formatName(item.name)} {formatName(item.patronymic)}
              </div>
              <div className={style.item} onClick={handleDriverClick} style={{ cursor: 'pointer' }}>
                <p>{item.idNumber}</p>
              </div>
              <div className={style.item} onClick={handleDriverClick} style={{ cursor: 'pointer' }}>
                +{item.phoneNumber}
              </div>
              <div className={style.item} onClick={handleLinkClick} style={{ cursor: 'pointer', justifyContent: 'center' }}>
                <RotateCcwKey
                  color={item?.driverComment ? "#ff0000" : "#6D7885"}
                  data-tooltip-id={`driver-link-tooltip-${item.id}`}
                />
                <AppTooltip id={`driver-link-tooltip-${item.id}`} place="top" positionStrategy="fixed">
                  {t('tooltips.createDriverLink')}
                </AppTooltip>
              </div>
              <div className={cn(style.item, style.item_status)} onClick={handleDriverClick} style={{ cursor: 'pointer' }}>
                <Badge type={item.isFree ? "green" : "gray"} text={item.isFree ? t("orderBooking.driverFree") : t("orderBooking.driverBusy")} />
              </div>
              <div className={cn(style.item, style.item_edit)} onClick={handleEditClick} style={{ cursor: 'pointer' }}>
                  <button
                    className={style.buttonEdit}
                    data-tooltip-id={`driver-edit-tooltip-${item.id}`}
                  >
                    <SquarePen size={20} />
                  </button>
                  <AppTooltip id={`driver-edit-tooltip-${item.id}`} place="top" positionStrategy="fixed">
                    {t('tooltips.editData')}
                  </AppTooltip>
              </div>
            </>
          )
        }
      </div>

      <InviteLinkModal
        isOpen={showModal}
        onClose={handleModalClose}
        inviteUrl={inviteUrl}
        expiry={expireLink}
      />

      <DriverInfoModal
        isOpen={showInfoModal}
        onClose={handleInfoModalClose}
        driverId={item?.id}
        onDriverUpdate={onDriverUpdate}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
      />
    </>
  );
};

export default DriverItemCard;